module.exports = __webpack_public_path__ + "media/images/flags/py-7f4d1c3191f55257b48725134780d2ea.svg";